export default __webpack_public_path__ + "5ac9da1d6e814aa7c891a7f1392c2a94.png";